// extracted by mini-css-extract-plugin
export var root = "style-module--root--u0v2Z";
export var segmented = "style-module--segmented--Nrt8N";
export var select = "style-module--select--i87Qv";